import { useContext, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Typography } from '@altermaind/web/ui';
import { ClaimsComponent } from '@/_shared/components/Claims';
import { LayoutContext } from '@/_shared/components/PageLayout';
import { Roles } from '@/_shared/constants/roles';
import { Sections, Tutorial } from '../components';

export const TrainingSoftSkillsScreen = () => {
  const t = useTranslations('trainingSoftSkills');
  const { setLayout } = useContext(LayoutContext);

  useEffect(() => {
    setLayout({ title: 'trainingSoftSkills' });
  }, [setLayout, t]);

  return (
    <>
      <ClaimsComponent roles={[Roles.Admin, Roles.HR_Delegate]}>
        <>
          <Typography variant='h1' mb='xs'>
            {t('trainingSoftSkillsTitleAdmin')}
          </Typography>
          <Typography variant='p2/light' color='grey/light' mb='m'>
            {t('description')}
          </Typography>
          <Tutorial.Admin />
        </>
      </ClaimsComponent>
      <ClaimsComponent roles={[Roles.Employee, Roles.Manager]}>
        <>
          <Typography variant='h1' mb='m'>
            {t('trainingSoftSkillsTitleEmployee')}
          </Typography>
          <Sections.MyContents />
          <Tutorial.Learning />
        </>
      </ClaimsComponent>
      <Sections.MainContents />
    </>
  );
};
